// extracted by mini-css-extract-plugin
module.exports = {"my_empty":"MyEmpty__my_empty___3r-Kv","my_empty_image":"MyEmpty__my_empty_image___ejF31","archived":"MyEmpty__archived___DWeSw"};